"use client"

import { useState } from "react"

/**
 * CoverImageAdaptive — 自适应封面图组件
 *
 * - 横图：宽度撑满，高度按比例自适应
 * - 竖图/方图：高度受 maxHeight 限制，宽度按比例缩小，居中展示
 * - 所有比例完整展示，不裁剪不拉伸
 */
export function CoverImageAdaptive({
  src,
  alt,
  maxHeight = 400,
}: {
  src: string
  alt: string
  maxHeight?: number
}) {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className="relative w-full overflow-hidden flex justify-center">
      {/* Skeleton placeholder */}
      {!loaded && (
        <div className="w-full aspect-video animate-pulse bg-muted/60" />
      )}

      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => setLoaded(true)}
        className={`block h-auto max-w-full transition-opacity duration-300 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        style={{ maxHeight }}
      />
    </div>
  )
}
